export const SHOW_SNACK = 'showSnack'
export const HIDE_SNACK = 'hideSnack'

export const APP_SET_MENU = 'appSetMenu'
export const APP_SET_NAVIGATION_STATUS = 'appSetMenuStatus'
export const APP_SET_CONNECTION = 'appSetConnectionError'
export const APP_SET_ERROR = 'appSetError'
export const APP_RESET_ERROR = 'appResetError'
export const APP_TOGGLE_LOADING_STATE = 'appToggleLoadingState'

export const LS_NAVIGATION_STATUS = 'app.Navigation.Status'

export const USER_SETDATA = 'userSetData'
export const USER_SET_RULES = 'userSetRules'
export const USER_ACCOUNTS_DATA = 'userAccountsData'

export const LEAD_CREDITOS_SIMULACAO = 'leadCreditosSimulacao'
export const LEAD_CREDITOS_PREANALISE = 'leadCreditosPreAnalise'

export const USUARIO_LOGADO_ID = 'usuarioLogadoID'

export const FORM_SEGURO_INCENDIO = 'formSeguroIncendio'

export const SET_ROUTER_DATATABLE = 'setRouterDataTable'
export const SET_TOKEN = 'setTokens'

export const SET_LGPD_STATUS = 'setLgpdStatus'

export const SET_PARAMETROS_PROPOSTA = 'setParametrosMinhasProposta'
export const SET_NOTIFICATIONS = 'SetNotifications'
